import { ASYNC_TYPES } from '@travel-frontend/state-handling-sdk';
import axios from '../../../../utils/axiosInstance.js';
export const SUBSCRIBE = 'newsletter/SUBSCRIBE';
export function subscribe({
  apiKey,
  email,
  origin,
  trackingSource,
  url
}) {
  return {
    types: ASYNC_TYPES(SUBSCRIBE),
    callAPI: () => axios.post(url, {
      email,
      type: 'newsletter',
      trackingSource,
      portal: `${origin.replace(/^https:\/\/[a-z]+\./, '')}`
    }, {
      headers: {
        'x-api-key': apiKey
      }
    }).then(res => res.data)
  };
}